import type { HeaderTab } from '@coorum-research/shared-common/api-response'
import { clsx } from 'clsx/lite'
import { MypageHeaderTabList } from './MypageHeaderTabList'

type Props = {
  className?: string
  title?: string
  tabs: HeaderTab[]
  mode: string
  onTabClick: (mode: string) => void
}

export function MypageHeader({ className, title, tabs, mode, onTabClick }: Props) {
  return (
    <div className={clsx('grid grid-cols-1 gap-2', className)}>
      {title && <h1 className="px-2 text-2xl font-bold">{title}</h1>}
      <MypageHeaderTabList
        tabs={tabs}
        mode={mode}
        onClick={onTabClick}
      />
    </div>
  )
}
